import { LoggerService } from '@app/shared/services/logger.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ISigningValuesInterface } from '@app/certificates/signing/signing';
import { HttpErrorHandler, HandleError } from '@app/shared/services/http-error-handler.service';
import { HeadersSetterHelper } from '@app/shared/helpers/http-headers-setter-helper';
import { Store } from '@ngrx/store';
import { cadesValues } from '@app/certificates/signing/signing.values';
import { pdfValues } from '@app/certificates/signing/signing.values';
import { xmlValues } from '@app/certificates/signing/signing.values';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '@app/config/app.config';
import { catchError, tap, map, delay, retry } from 'rxjs/operators';
import { observeTypes, ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';

@Injectable()
export class SigningService {
  private handleError: HandleError;
  private headerHelper: HeadersSetterHelper;

  constructor(
    private httpErrorHandler: HttpErrorHandler,
    private http: HttpClient,
    private store: Store<any>,
    private logger: LoggerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('SigningService');
    this.headerHelper = new HeadersSetterHelper(this.store);
  }

  sendForSigning(formData: FormData): Observable<ISpringResponseBody> {
    return this.http.post<ISpringResponseBody>(
      AppConfig.endpoints.operations.sign, formData, this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('signError')),
      map((res: ISpringResponseBody) => {
        this.logger.log(res);
        return res;
      }));
  }

  sendPackageForSigning(data: any): Observable<ISpringResponseBody> {
    return this.http.post<ISpringResponseBody>(
      AppConfig.endpoints.operations.sendPackage, data, this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('signError')),
      map((res: ISpringResponseBody) => {
        this.logger.log(res);
        return res;
      }));
  }

  // sending documnetRequestId by get request and waiting meanwhile pulling every 2 sec for action in mobile app
  pullUntilSigning(docId: string): Observable<ISpringResponseBody | any> {
    console.log('docId', docId)
    return this.http.get(
      AppConfig.endpoints.operations.getSignDocStatus + '/' + docId,
      this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      delay(AppConfig.pullSigningTimeout),
      catchError(this.handleError('sendDocId')),
      map(res => {
        if (res['status'] === 202) {
          throw 202;
        }
        return res;
      }),
      retry({
        delay: errors => of(errors).pipe(tap(val => console.log('Waiting for signing by mobile app ...')))
      }
      )
    );
  }

  pullUntilSigningBusiness(docId: string, companyCmrId: string): Observable<ISpringResponseBody | any> {
    return this.http.get(
      AppConfig.endpoints.operations.getSignDocStatus + '/company/' + docId + '/' + companyCmrId, this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      delay(AppConfig.pullSigningTimeout),
      catchError(this.handleError('sendDocId')),
      map(res => {
        if (res['status'] === 202) {
          throw 202;
        }
        return res;
      }),
      retry({
        delay: errors => of(errors).pipe(tap(val => console.log('Waiting for signing by mobile app ...')))
      }
      )
    );
  }

  // Return observable of all response headers for geting filename and body type blob to make possible downloading signed file later
  public getFile(_signDocReqId: string): Observable<any> {
    return this.http.get(
      AppConfig.endpoints.storage.getFile + '/' + _signDocReqId,
      this.headerHelper.fileOptions(observeTypes.RESPONSE, 'blob')
    ).pipe(
      catchError(this.handleError('getFile'))
    );
  }

  public getRequestedFile(_signDocReqId: string): Observable<any> {
    return this.http.get(
      AppConfig.endpoints.storage.getRequestedFile + '/' + _signDocReqId,
      this.headerHelper.fileOptions(observeTypes.RESPONSE, 'blob')
    ).pipe(
      catchError(this.handleError('getFile'))
    );
  }

  public getFileForPreview(usageId: string): Observable<any> {
    return this.http.get(
      AppConfig.endpoints.operations.preview + '/' + usageId,
      this.headerHelper.fileOptions(observeTypes.RESPONSE, 'blob')
    ).pipe(
      catchError(this.handleError('getFilePreview'))
    );
  }

  public getReport(_signDocReqId: string, _reportType: string): Observable<any> {
    return this.http.get(
      AppConfig.endpoints.storage.getReport + '/' + _signDocReqId + '/' + _reportType,
      this.headerHelper.fileOptions(observeTypes.RESPONSE, 'blob')
    ).pipe(
      catchError(this.handleError('getReport'))
    );
  }

  values(fileExtension: string): Observable<ISigningValuesInterface> {
    let values;
    switch (fileExtension.toLocaleLowerCase()) {
      case 'pdf':
        values = { ...pdfValues };
        break;
      case 'xml':
        values = { ...xmlValues };
        break;
      default:
        values = { ...cadesValues };
        break;
    }
    return of(values);
  }
  sendPackageForSigningOTC(companyCmrId: any, data: any, sessionId: any, resultId: any, status: any): Observable<any> {
    return this.http.post<any>(
      AppConfig.endpoints.operations.sendPackageOtc.replace('{companyCrmId}', `${companyCmrId}`).replace('{sessionId}', `${sessionId}`).replace('{resultId}', `${resultId}`).replace('{status}', `${status}`), data, this.headerHelper.options(observeTypes.BODY)
    ).pipe(
      catchError(this.handleError('signError')),
      map((res: any) => {
        this.logger.log(res);
        return res;
      }));
  }
}
